var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalenderList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5B9306CA-C276-4B6C-ACAD-73AC5CD2327E") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Asset-Artboard-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-calender-Icon-/-calender_list",
    stroke: "#8D8F93"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calendar",
    transform: "translate(7.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 1.11111111,
    width: 10,
    height: 10,
    rx: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.22222222,
    y1: 0,
    x2: 7.22222222,
    y2: 2.22222222,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.77777778,
    y1: 0,
    x2: 2.77777778,
    y2: 2.22222222,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 4.44444444,
    x2: 10,
    y2: 4.44444444,
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderList);
export default __webpack_public_path__ + "static/media/calender_list.ccfac6f45d648d356d59e5ef8539524f.svg";
export { ForwardRef as ReactComponent };